import { createStore } from 'zustand'
import { SetPasswordState, SetPasswordStore } from '@/scopes/auth/domain/types'

const SET_PASSWORD_TOKEN_QUERY_PARAM = 'token'

export function createInitialSetPasswordState(search: string): SetPasswordState {
  return {
    token: new URLSearchParams(search).get(SET_PASSWORD_TOKEN_QUERY_PARAM) || null,
    linkError: null,
    pageInitializationStatus: 'idle',
    submitStatus: 'idle',
    submitError: null,
  }
}

export function createSetPasswordStore(initialState: SetPasswordState = createInitialSetPasswordState('')) {
  return createStore<SetPasswordStore>(set => ({
    ...initialState,
    setIn: (key, value) => {
      set(state => ({ ...state, [key]: value }))
    },
  }))
}
